import cronstrue from "cronstrue";
export function describeExpression(expression) {
  if (expression) {
    return cronstrue.toString(expression, { throwExceptionOnParseError: false, dayOfWeekStartIndexZero: false });
  }
  return null;
}
